module.exports = __webpack_public_path__ + "img/symbols.dafb4c64.svg";